import React from 'react'

import Header from '../components/Header'
import Hero from '../components/Hero'
import About from '../components/About'
import Brand from '../components/Brand'
import Footer from '../components/Footer'

function LandingPage() {
  return (
    <>
    <Header/>
    <Hero/>
    <Brand/>
    <About/>
    <Footer/>
    </>
  )
}

export default LandingPage